import { enUS } from 'date-fns/locale';

var en = {
  formats: {
    date: "dd.mm.yyyy",
    dateMonth: "mm.yyyy",
    weekStartsOnSunday: false,
    dateLocale: enUS,
    quotationMarkOpening: "“",
    quotationMarkClosing: "”"
  },
  texts: {
    lsg: {
      component: {
        _general: {
          optional: "optional"
        },
        BankingCard: {
          titles: {
            giro: "Girocard",
            giro_old: "Girocard",
            info: "Infocard",
            spar: "Sparcard",
            flexi: "Flexicard",
            einzahl: "Einzahlcard"
          },
          cardNumber: "Card-No.",
          validThru: "Valid thru"
        },
        BreadCrumbs: {
          title: "Bread Crumbs"
        },
        CcsApprovalPanel: {
          layerBackButton: "Back",
          technicalErrorTitle: "Technical error",
          technicalErrorSubtitle: "This feature is not available due to a technical error.",
          cancelButton: "Cancel",
          technicalErrorSubline: "Details at the bottom of the page",
          inputAtBottomSubline: "Input at the bottom of the page",
          detailsAtBottomSubline: "Details at the bottom of the page",
          confirmationAtBottomSubline: "Confirmation at the bottom of the page",
          redirectSubline: "You will now be redirected"
        },
        ClickList: {
          selected: "Selected"
        },
        ComplexTable: {
          sortAscending: "sort ascending",
          sortDescending: "sort descending",
          sortedAscending: "sorted ascending",
          sortedDescending: "sorted descending",
          labelSortLayer: "Order by",
          labelSortLayerBackButton: "Back",
          labelSortMenu: "Order"
        },
        ContentWrapper: {
          closeLayer: "back to overview",
          showDetails: "Show details"
        },
        DataTable: {
          moreFields: "More fields",
          selectAll: "Select all",
          deselectAll: "Deselect all"
        },
        DetailPageHeader: {
          backButton: "Back"
        },
        Feedback: {
          trueButton: "Yes",
          falseButton: "No",
          result: "Thanks for your feedback."
        },
        Footer: {
          claim: "The bank at your side"
        },
        Header: {
          myBanking: "My banking",
          search: "Search",
          openMenu: "open menu",
          closeDrawer: "close menu"
        },
        IconLink: {
          defaultAriaLabel: "Button with {{label}} symbol"
        },
        InputDatepicker: {
          placeholder: "DD.MM.YYYY",
          placeholderMonthYear: "MM.YYYY",
          label: "Date",
          error: "Please enter a valid date at the format {{format}}.",
          openCalendar: "open calendar",
          nextMonth: "next month",
          previousMonth: "previous month",
          nextYear: "next year",
          previousYear: "previous year",
          cancelButton: "Cancel",
          confirmButton: "Confirm"
        },
        InputSelect: {
          error: "Please select an option.",
          open: "open selection options",
          close: "close selection options",
          empty: "no entries"
        },
        InputTextfield: {
          clear: "clear input",
          reveal: "show password"
        },
        InputSearch: {
          placeholder: "search",
          clear: "reset search field"
        },
        InputSlider: {
          minimalShortened: "min",
          maximalShortened: "max"
        },
        Logo: {
          title: "Company Logo",
          titleCoba: "Commerzbank Logo",
          actionHome: "To company home page"
        },
        OnPageNavigation: {
          backtoTop: "Back to top"
        },
        ProcessHeader: {
          openMenu: "open menu"
        },
        ProfileWidget: {
          closeMenu: "close",
          logout: "Log out"
        },
        ProfileButton: {
          login: "Log in"
        },
        SideNavigation: {
          openMenu: "open menu",
          closeMenu: "close menu"
        },
        SliderPagination: {
          nextPage: "next page",
          previousPage: "previous page",
          pagination: "page selection"
        },
        Stage: {
          scrollerText: "Read more..."
        },
        Video: {
          replay: "Replay",
          notSupported: "Your browser does not support video playback.",
          play: "Play",
          pause: "Pause",
          mute: "Mute",
          unMute: "Unmute",
          fullScreen: "Enter/exit fullscreen",
          captionOn: "Show captions",
          captionOff: "Hide captions"
        }
      },
      icon: {
        _default: "icon",
        banking___3rateCredit: "3-rate-credit",
        banking___atm: "ATM",
        banking___bank: "bank",
        banking___cashradar: "radar",
        banking___cobaMultichannel: "Commerzbank multichannel",
        banking___contactless: "contactless",
        banking___gem: "gemstone",
        banking___giropayP2p: "Giropay",
        banking___goldbars: "goldbars",
        banking___handMoney: "hand money",
        banking___handsMoney: "hands money",
        banking___loanMobile: "loan mobile",
        banking___mobileEuro: "Euro mobile",
        banking___multibanking: "multi-banking",
        banking___phototan: "photo tan",
        banking___piggybank: "piggy bank",
        banking___pincode: "pin code",
        banking___vault: "vault",
        banking_card_addCard: "add card",
        banking_card_appleWallet: "Apple wallet",
        banking_card_blockCard: "block card",
        banking_card_cardArrows: "card with arrows",
        banking_card_cardGreen: "card with leaf",
        banking_card_multipleCards: "multiple cards",
        banking_card_searchCard: "card search",
        banking_card_singleCard: "single card",
        banking_cash_3Coins: "Euro coins",
        banking_card_wrongPayment: "wrong payment",
        banking_cash_banknoteEur: "Euro bill",
        banking_cash_banknoteGreen: "Euro bill with leaf",
        banking_cash_banknoteUsd: "US Dollar bill",
        banking_cash_coinArrowleft: "Euro coin arrow left",
        banking_cash_coinArrowright: "Euro coin arrow right",
        banking_cash_coinBtc: "Bitcoin",
        banking_cash_coinEur: "Euro coin",
        banking_cash_coinGreen: "Euro coin with leaf",
        banking_cash_coinstack: "coin stack",
        banking_graphs_benchmark: "bar chart",
        banking_graphs_graph: "line chart",
        banking_graphs_green: "line chart with leaf",
        banking_graphs_piechart: "pie chart",
        banking_transfer_standingOrder: "standing order",
        banking_transfer_transferRebooking: "transfer rebooking",
        banking_transfer_transferReceive: "transfer receive",
        banking_transfer_transferRecurring: "transfer recurring",
        banking_transfer_transferScheduled: "transfer scheduled",
        banking_transfer_transferStandard: "transfer",
        banking_transfer_transferslip: "transfer slip",
        brands___apple: "logo Apple",
        brands___fitbit: "Logo Fitbit",
        brands___garmin: "Logo Garmin",
        brands___google: "logo Google",
        brands___swatch: "Logo Swatch",
        brands___visa: "logo Visa",
        brands___mastercard: "Logo Mastercard",
        brands_banks_comdirect: "logo Comdirect",
        brands_banks_commerzbank: "logo Commerzbank",
        brands_banks_deutschebank: "logo Deutsche Bank",
        brands_banks_ing: "logo ING",
        brands_banks_n26: "logo N26",
        brands_banks_postbank: "logo Postbank",
        brands_banks_sparkasse: "logo Sparkasse",
        brands_banks_targo: "logo Targobank",
        communication___call: "call",
        communication___chat: "chat",
        communication___envelope: "envelope",
        communication___envelopeRead: "envelope open",
        communication___envelopeUnread: "envelope unread",
        communication___handPointing: "hand pointing",
        communication___handHeart: "hand pointing heart",
        communication___handsCare: "hands care",
        communication___headsetHead: "head with headset",
        communication___inbox: "inbox",
        communication___news: "news",
        communication___operator: "operator",
        communication___recommendation: "recommendation",
        communication___textchat: "text chat",
        communication___videochat: "video chat",
        communication_feedback_agreement: "handshake",
        communication_feedback_boring: "boring",
        communication_feedback_dislike: "dislike",
        communication_feedback_happy: "happy",
        communication_feedback_like: "like",
        communication_feedback_neutral: "neutral",
        communication_feedback_sad: "sad",
        communication_feedback_smile: "smile",
        interaction___add: "add",
        interaction___backToTop: "back to top",
        interaction___bluetoothOn: "bluetooth enabled",
        interaction___checkmark: "confirm",
        interaction___close: "close",
        interaction___copy: "copy",
        interaction___dashLong: "long dash",
        interaction___dashShort: "short dash",
        interaction___download: "download",
        interaction___eyeHide: "hide",
        interaction___eyeView: "show",
        interaction___faceid: "Face ID",
        interaction___filter01: "filter",
        interaction___filter02: "filter",
        interaction___fingerprint: "fingerprint",
        interaction___flashOff: "flash disabled",
        interaction___flashOn: "flash enabled",
        interaction___fullscreenEnter: "fullscreen on",
        interaction___fullscreenExit: "fullscreen off",
        interaction___history: "history",
        interaction___logout: "logout",
        interaction___menu: "menu",
        interaction___menuGrid: "menu grid",
        interaction___more01: "more",
        interaction___more02: "more",
        interaction___notificationOff: "notifications off",
        interaction___notificationOn: "notifications on",
        interaction___pause: "pause",
        interaction___playbutton: "play",
        interaction___refresh: "refresh",
        interaction___replay: "replay",
        interaction___save: "save",
        interaction___search: "search",
        interaction___share: "share",
        interaction___slider: "settings",
        interaction___touchid: "Touch ID",
        interaction___trash: "delete",
        interaction___uploadCloud: "upload cloud",
        interaction___upload: "upload",
        interaction___volumeLow: "volume low",
        interaction___volumeOff: "volume off",
        interaction___volume: "volume",
        interaction___wifiOff: "wifi off",
        interaction___wifiOn: "wifi on",
        interaction_arrows_arrowDown: "arrow down",
        interaction_arrows_arrowLeft: "arrow left",
        interaction_arrows_arrowLeftright: "arrow left right",
        interaction_arrows_arrowRight: "arrow right",
        interaction_arrows_arrowUp: "arrow up",
        interaction_arrows_chevronDown: "chevron down",
        interaction_arrows_chevronLeft: "chevron left",
        interaction_arrows_chevronRight: "chevron right",
        interaction_arrows_chevronUp: "chevron up",
        location___cobaGreen: "Commerzbank tower with leaf",
        location___cobaTower: "Commerzbank tower",
        location___direction: "direction",
        location___energyfarm: "energy farm",
        location___globe: "globe",
        location___globeGreen: "globe with leaf",
        location___house: "house",
        location___location: "location",
        location___office: "office",
        location___officeGreen: "office with leaf",
        location___target: "target",
        object___alarmclock: "alarm",
        object___bug: "bug",
        object___book: "book",
        object___briefcase: "briefcase",
        object___calender: "calender",
        object___clock: "clock",
        object___coffeemug: "coffee mug",
        object___compass: "compass",
        object___firstaid: "first aid",
        object___flag: "flag",
        object___flowerBouquet: "flower bouquet",
        object___gauge: "gauge",
        object___gear: "gear",
        object___groceries: "groceries",
        object___groceriesGreen: "groceries with leaf",
        object___industryRobot: "industry robot",
        object___key: "key",
        object___knifeFork: "knife fork",
        object___lightbulb: "light bulb",
        object___lock: "lock",
        object___lockOpen: "lock open",
        object___paperclip: "paper clip",
        object___pencil: "pencil",
        object___rockingChair: "rocking chair",
        object___shieldCheckmark: "shield with checkmark",
        object___shoppingbagsGreen: "shopping bag with leaf",
        object___shoppingcart: "shopping cart",
        object___sofa: "sofa",
        object___snowflake: "snowflake",
        object___snowflakeAttention: "snowflake with exclamation mark",
        object___noSnowflake: "snowflake strikethrough",
        object___stopwatch: "stopwatch",
        object___sprout: "sprout",
        object___suitcase: "suitcase",
        object___sun: "sun",
        object___tag: "tag",
        object___torch: "torch",
        object___umbrella: "umbrella",
        object___wrench: "wrench",
        object_devices_calculator: "calculator",
        object_devices_camera: "camera",
        object_devices_keyboard: "keyboard",
        object_devices_headset: "headset",
        object_devices_laptop: "laptop",
        object_devices_microphone: "microphone",
        object_devices_printer: "printer",
        object_devices_responsive: "devices responsive",
        object_devices_smartphone: "smartphone",
        object_devices_tablet: "tablet",
        object_devices_video: "video",
        object_document_certificate: "certificate",
        object_document_checklist: "checklist",
        object_document_document: "document",
        object_document_documentArrow: "document with arrow",
        object_document_documentMinus: "delete document",
        object_document_documentPlus: "add document",
        object_document_folderOpen: "folder open",
        object_document_questionnaire: "questionnaire",
        object_document_signature: "signature",
        object_nature_bee: "bee",
        object_nature_bug: "bug",
        object_nature_cloud: "cloud",
        object_nature_palmtree: "palm tree",
        object_nature_sprout: "sprout",
        object_shieldCheckmark: "shield with checkmark",
        object_transport_airplane: "airplane",
        object_transport_automobile: "car",
        object_transport_bicycle: "bicycle",
        object_transport_campervan: "campervan",
        object_transport_caravan: "caravan",
        object_transport_carGreen: "car with leaf",
        object_transport_motorcycle: "motorcycle",
        object_transport_pram: "baby carriage",
        object_transport_trailer: "trailer",
        object_transport_train: "train",
        object_transport_wheel: "wheel",
        people___businessMale: "business male",
        people___callcenter: "call center",
        people___childFemale: "girl",
        people___childMale: "boy",
        people___female: "female",
        people___fullbodyFemale: "fullbody female",
        people___fullbodyMale: "fullbody male",
        people___fullbodyProfile: "fullbody profile",
        people___groupFemale: "group female",
        people___groupMale: "group male",
        people___hipsterMale: "hipster male",
        people___male: "male",
        people___photoId: "ID card",
        people___privacySpy: "spy",
        people___profileAdd: "add profile",
        people___profileAttention: "profile picture with exclamation mark",
        people___profileEuro: "profile with Euro sign",
        people___profileHistory: "profile history",
        people___profile: "profile",
        people___teacherPresent: "teacher present",
        people___teamFemale: "team female",
        people___teamMale: "team male",
        people___wheelchair: "wheelchair",
        social___cobablog: "Commerzbank blog",
        social___facebook: "Facebook",
        social___instagram: "Instagram",
        social___linkedin: "LinkedIn",
        social___pinterest: "Pinterest",
        social___tiktok: "TikTok",
        social___twitter: "Twitter",
        social___xing: "Xing",
        social___youtube: "YouTube",
        symbols___asterisk: "asterisk",
        symbols___at: "at sign",
        symbols___blockchain: "blockchain",
        symbols___co2Footprint: "CO2 footprint",
        symbols___digitalisation: "digitalisation",
        symbols___error: "error",
        symbols___exclamationmark: "exclamation mark",
        symbols___heart: "heart",
        symbols___infoCircle: "info circle",
        symbols___info: "info",
        symbols___legal: "legal",
        symbols___music: "music",
        symbols___peace: "peace",
        symbols___percentage: "percentage",
        symbols___questionmarkCircle: "question mark circle",
        symbols___questionmark: "question mark",
        symbols___quotationmark: "quotation mark",
        symbols___recycle: "recycle",
        symbols___slashCircle: "slash circle",
        symbols___uncategorized: "uncategorized"
      }
    }
  }
};

export { en };
